module.exports = __webpack_public_path__ + "img/9788958289890.fdfa0106.jpg";